// extracted by mini-css-extract-plugin
export default {"youtubeContainer":"YouTube_youtubeContainer__wuLRH"};